import AptResEast from "./AptRes-East.png";
import AptResWest from "./AptRes-West.png";
import BL113 from "./BL113.png";
import Blumberg from "./Blumberg.png";
import BSB from "./BSB.png";
import Crapo2 from "./Crapo 2.png";
import Crapo3 from "./Crapo 3.png";
import D116 from "./D116.png";
import Deming from "./Deming.png";
import DemingAttic from "./DemingAttic.png";
import F217 from "./F217.png";
import F225 from "./F225.png";
import hmu100ricoh from "./hmu100-ricoh.png";
import LakeSide1 from "./Lake Side 1.png";
import LakeSide3 from "./Lake Side 3.png";
import m242 from "./m242.png";
import Mees from "./Mees.png";
import NABJ105 from "./NAB-J105.png";
import O157 from "./O157.png";
import O200C from "./O200C.png";
import O257 from "./O257.png";
import Percopo0 from "./Percopo 0.png";
import Percopo1 from "./Percopo 1.png";
import Percopo3 from "./Percopo 3.png";
import Scharp from "./Scharp.png";
import Speed from "./Speed.png";

const maps = {
  AptResEast,
  AptResWest,
  BL113,
  Blumberg,
  BSB,
  Crapo2,
  Crapo3,
  D116,
  Deming,
  DemingAttic,
  F217,
  F225,
  hmu100ricoh,
  LakeSide1,
  LakeSide3,
  m242,
  Mees,
  NABJ105,
  O157,
  O200C,
  O257,
  Percopo0,
  Percopo1,
  Percopo3,
  Scharp,
  Speed,
};

export default maps;
